import React from "react";
import { Tag } from "antd";

import styles from "./styles/SearchTags.scss";
import { getIconUrl } from "../../services/asset";

function SearchTags({ onTagRemove, tags, className, onResetAllTags }) {
  return (
    <div className={className}>
      {tags.length > 0 ? (
        <div
          role="button"
          tabIndex={0}
          onClick={onResetAllTags}
          className={styles.resetAllTags}
        >
          {"Resetiraj sve"}
        </div>
      ) : null}
      {tags.map((tag: any) => (
        <Tag key={tag.id} className={styles.mainTags}>
          <span>{tag.name}</span>
          <img
            alt={tag.name}
            src={getIconUrl("remove.svg")}
            onClick={() => onTagRemove(tag)}
            role="presentation"
          />
        </Tag>
      ))}
    </div>
  );
}

SearchTags.defaultProps = {
  className: ""
};

export default SearchTags;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchTags.tsx